import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";

const UpdateFormMetadata = ({ metadata, getStudyLevelForm, Show, Hide, Title, setFormId }) => {
  const [formName, setFormName] = useState("");
  const [formLabel, setFormLabel] = useState("");
  const [formCode, setFormCode] = useState("");
  const [domainClassType, setDomainClassType] = useState("");
  const [domainCode, setDomainCode] = useState("");
  const [domainLabel, setDomainLabel] = useState("");
  const [formType, setFormType] = useState("regular");
  const [formRepeat, setFormRepeat] = useState("no");
  const [formCategory, setFormCategory] = useState("eventForm");
  const [customForm, setCustomForm] = useState("no");
  const [unbliendForm, setUnbliendForm] = useState("no");
  const [unscheduledForm, setUnscheduledForm] = useState("no");
  const [initiateOrder, setInitiateOrder] = useState("formOrder");
  let { studyId } = useParams()
  const [updateButtonLoader, setUpdateButtonLoader] = useState(false)

  const updateStudyLevelForm = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Form Metadata!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setUpdateButtonLoader(true)
        let userData = {};
        userData.id = metadata?._id;
        userData.studyId = studyId
        userData.formName = formName
        userData.formLabel = formLabel
        userData.formCode = formCode
        userData.domainClassType = domainClassType
        userData.domainCode = domainCode
        userData.domainLabel = domainLabel
        userData.formType = formType
        userData.formRepeat = formRepeat
        userData.formCategory = formCategory
        userData.customForm = customForm
        userData.unbliendForm = unbliendForm
        userData.unscheduledForm = unscheduledForm
        userData.initiateOrder = initiateOrder
        let data = await studyLevelFormManagementServices.updateStudyLevelForm(userData);
        if (data?.statusCode === 200) {
          getStudyLevelForm();
          Hide()
          setFormId("")
        }
      }
      setUpdateButtonLoader(false)
    });
  };

  useEffect(() => {
    setFormName(metadata?.formName)
    setFormLabel(metadata?.formLabel)
    setFormCode(metadata?.formCode)
    setDomainClassType(metadata?.domainClassType)
    setDomainCode(metadata?.domainCode)
    setDomainLabel(metadata?.domainLabel)
    setFormType(metadata?.formType || "regular")
    setFormRepeat(metadata?.formRepeat || "no")
    setFormCategory(metadata?.formCategory || "eventForm")
    setCustomForm(metadata?.customForm || "no")
    setUnbliendForm(metadata?.unbliendForm || "no")
    setUnscheduledForm(metadata?.unscheduledForm || "no")
    setInitiateOrder(metadata?.initiateOrder || "formOrder")
  }, [metadata]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title
          >
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setFormName(e.target.value)}
              value={formName}
              className="br3"
              placeholder="Form Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setFormLabel(e.target.value)}
              value={formLabel}
              className="br3"
              placeholder="Form Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form Code{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                setFormCode(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              disabled={metadata?.qualityCheck === "yes"}
              value={formCode}
              className="br3"
              placeholder="Form Code"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Domain Class Type{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setDomainClassType(e.target.value)}
              value={domainClassType}
              className="br3"
              disabled={metadata?.qualityCheck === "yes"}
              placeholder="Domain Class Type"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Domain Label{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setDomainLabel(e.target.value)}
              value={domainLabel}
              className="br3"
              disabled={metadata?.qualityCheck === "yes"}
              placeholder="Domain Label"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Domain Code{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => {
                const input = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
                setDomainCode(input);
              }}
              onKeyDown={(e) => {
                if (e.key === " ") {
                  e.preventDefault();
                }
              }}
              disabled={metadata?.qualityCheck === "yes"}
              value={domainCode}
              className="br3"
              placeholder="Domain Code"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form Type{" "}
              <abbr title="Required" className="text-danger">*</abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setFormType(e.target.value)}
              className="br3"
              disabled={metadata?.qualityCheck === "yes"}
              style={{ fontSize: 12 }}
            >
              <option selected={formType === ""} value="">Select Form Type</option>
              <option selected={formType === "regular"} value="regular">Regular</option>
              <option selected={formType === "log"} value="log">Log</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form Repeat{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setFormRepeat(e.target.value)}
              className="br3"
              style={{ fontSize: 12 }}
            >
              <option selected={formRepeat === ""} value="">Select Form Repeat</option>
              <option selected={formRepeat === "yes"} value="yes">Yes</option>
              <option selected={formRepeat === "no"} value="no">No</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Form Category{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => {
                setFormCategory(e.target.value);
                setUnscheduledForm('no')
              }}
              className="br3"
              style={{ fontSize: 12 }}
            >
              <option selected={formCategory === ""} value="">Select Form Category</option>
              <option selected={formCategory === "initiateForm"} value="initiateForm">Initiate Form</option>
              <option selected={formCategory === "eventForm"} value="eventForm">Event Form</option>
              <option selected={formCategory === "specialForm"} value="specialForm" id="">Special Form</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Unscheduled Form{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setUnscheduledForm(e.target.value)}
              className="br3"
              disabled={formCategory === "specialForm"}
              style={{ fontSize: 12 }}
            >
              <option selected={unscheduledForm === ""} value="">Select Unscheduled Form</option>
              <option selected={unscheduledForm === "no"} value="no">No</option>
              <option selected={unscheduledForm === "yes"} value="yes">Yes</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Custom Form{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setCustomForm(e.target.value)}
              className="br3"
              style={{ fontSize: 12 }}
            >
              <option selected={customForm === ""} value="">Select Custom Form</option>
              <option selected={customForm === "no"} value="no">No</option>
              <option selected={customForm === "tenderSwallen"} value="tenderSwallen">Tender/Swallen</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Bliend Form{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setUnbliendForm(e.target.value)}
              className="br3"
              style={{ fontSize: 12 }}
            >
              <option selected={unbliendForm === ""} value="">Select Bliend Form</option>
              <option selected={unbliendForm === "no"} value="no">No</option>
              <option selected={unbliendForm === "yes"} value="yes">Yes</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Initiate Order{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Select
              onChange={(e) => setInitiateOrder(e.target.value)}
              className="br3"
              style={{ fontSize: 12 }}
            >
              <option selected={initiateOrder === ""} value="">Select Initiate Order</option>
              <option selected={initiateOrder === "formOrder"} value="formOrder">Form Order</option>
              <option selected={initiateOrder === "anyTime"} value="anyTime">Any Time</option>
            </Form.Select>
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!formName || !formLabel || !formCode || !domainClassType || !domainLabel || !domainCode || !formType || !formRepeat || !formCategory || !unscheduledForm || !unbliendForm || !customForm || !initiateOrder || updateButtonLoader}
            className="updateProfile"
            onClick={(e) => updateStudyLevelForm(e)}
          >
            {updateButtonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Metadata"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateFormMetadata;
